const getFormContainingField = require("../form/getFormContainingField");
const getMarketoIdFromForm = require("../marketo/getMarketoIdFromForm");
const loadMarketoForm = require("../marketo/loadMarketoForm");
const getCountryOptionsHtmlFromTheMarketoForm = require("./getCountryOptionsHtmlFromTheMarketoForm");
const removeMarketoFormEmbed = require("../marketo/removeMarketoFormEmbed");

/**
 * @param countrySelect {HTMLSelectElement}
 * @return {Promise<void>}
 */
module.exports = async function initializeCountryOptionsWithMarketoOptions(countrySelect) {
    const form = getFormContainingField(countrySelect);

    if (form) {
        const marketoFormId = getMarketoIdFromForm(form);

        if (marketoFormId) {
            const {marketoForm, marketoFormContainer} = await loadMarketoForm(marketoFormId);

            countrySelect.innerHTML = getCountryOptionsHtmlFromTheMarketoForm(marketoForm);

            removeMarketoFormEmbed(marketoFormContainer);
        }
    }
}